import type { FluentIcon } from '@fluentui/react-icons'
import { CheckmarkCircleRegular } from '@fluentui/react-icons'
import styles from './CapabilityCard.module.css'

interface CapabilityCardProps {
  icon?: FluentIcon
  eyebrow?: string
  title: string
  points: string[]
}

export function CapabilityCard({ icon: Icon, eyebrow, title, points }: CapabilityCardProps) {
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        {Icon && (
          <span className={styles.iconWrap}>
            <Icon className={styles.icon} aria-hidden="true" />
          </span>
        )}
        <div>
          {eyebrow && <span className={styles.eyebrow}>{eyebrow}</span>}
          <h3 className={styles.title}>{title}</h3>
        </div>
      </div>
      <ul className={styles.list}>
        {points.map((point) => (
          <li key={point} className={styles.item}>
            <CheckmarkCircleRegular className={styles.check} aria-hidden="true" />
            <span>{point}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
